/**
 * @Author: DJ
 * @Date:   2021-07-19 16:00:43
 * @Last Modified by:   DJ
 * @Last Modified time: 2021-09-07 19:41:47
 */
/**
 * 配送订单管理
 */
 import React from 'react';
 import PropTypes from 'prop-types';
 import styles from './index.module.scss';
 import { connect } from 'react-redux';
 import moment from 'moment';
 import { XInput, XInputNum, XSelect, XDatePicker, XOKButton, XCancelButton, XTabNav } from '@/components/xqxc_ui';
 import TableContent from './components/OrderTable';
 import MultiorderContent from '../multiorder';
 import KeepAlive from '@/routes/KeepAlive';
 import model from '@/reducers/order/microshippingorder/model';
 import { autoPageNum, autopageSize } from '@/assets/config';
 import { SearchBox, SearchItem } from '@/components/Layout';
 import { setBreadcrumbPaths } from '@/reducers/home/actions';
 
 class Main extends React.Component {
 
     state = {
         isDelay: {}, // 是否超时
         status: {}, // 状态
         type: {}, // 订单类型
         opId: {}, //运营公司
         shareLoading: false,
         tab: [
             { id: 1, label: '全部' },
             { id: 2, label: '待支付' },
             { id: 3, label: '异常' },
             { id: 4, label: '一路多单' },
         ],
         curTabID: 1,  // 当前显示的Tab页ID
     };
 
     componentDidMount() {
         const { history: { location: { curTabID } } } = this.props;
         if (curTabID) {
             this.setState({ curTabID });
         }
         this.props.setBreadcrumbPaths(this.props.match); // 自动识别面包屑
         // 状态枚举
         this.props.getDeliveryOrderStatus({ enumName: 'DeliveryStatusEnum' });
         // 订单类型
         this.props.getOrderDeliveryTypeEnum({ enumName: 'OrderDeliveryTypeEnum' });
         // 运营公司
         this.props.getCompanyItem({ pageSize: 10000 });
     }
     // Tab页切换
     _tabChangeHandle = (tabID) => {
         this.setState({
             curTabID: tabID,
         }, () => {
             if (tabID !== 4) {
                 this._searchHandle('useCache');
             }
         });
     }
     // 表格操作
     _tableAction = (key, type, record) => {
         const { history } = this.props;
         switch (type) {

             // 详情
             case 'info':
                 history.push({
                     pathname: `/home/order/microshippingorder/orderdetail/${record.id}`,
                 });
                 break;
             // 操作记录
             case 'history':
                 history.push({
                     pathname: `/home/order/microshippingorder/orderhistory/${record.id}`,
                 });
                 break;
         }
 
     }
 
     // 查询触发
     _searchHandle = (useCache) => {
         const { curTabID, pageNum, pageSize, id, riderPhone, shipperPhone, consigneePhone,
             opId, type, isDelay, status, createTimeStart, createTimeEnd
         } = this.state;
         const query = {
             id,
             riderPhone,
             shipperPhone,
             consigneePhone,
             opId: opId.companyId,
             type: type.code,
             isDelay: isDelay.code,
             startTime: createTimeStart,
             endTime: createTimeEnd,
             status: curTabID == 1 ? status.code : curTabID == 2 ? 'PAYING' : curTabID == 3 ? 'UNDELIVERED' : '',
             pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
             pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
         };
         if (curTabID !== 4) {
             this.props.getDeliveryOrderList(query);
         }
         KeepAlive.saveCache({ ...this.state, pageNum: query.pageNum, pageSize: query.pageSize });
     }
 
     // 重置触发
     _resetHandle = () => {
         this.setState({
             id: undefined, riderPhone: undefined, shipperPhone: undefined, consigneePhone: undefined,
             opId: {}, type: {}, isDelay: {}, createTimeStart: undefined, createTimeEnd: undefined, status: {}, pageNum: 1, pageSize: 10
         }, () => {
             KeepAlive.saveResetFunc(this._searchHandle);
         });
     }
 
     // 每页pageSize条，当前第pageNum页
     _paginationChange = (pageSize, pageNum) => {
         this.setState({ pageSize, pageNum }, () => {
             this._searchHandle('useCache');
         });
     }
     startDate = () => {
         this.setState({ createTimeEnd: undefined });
     }
     disabledDate = (current) => {
         const { createTimeStart } = this.state;
         let enddays = createTimeStart && moment(createTimeStart);
         return current && current < enddays && enddays.startOf('day');
     }
     deliveryIdHandle = e => {
         var value = e.target.value;
         const reg = /^[0-9a-zA-Z]*$/; // 数字、字母
         if (value && value.toString().length > 21) {
             return;
         } else if (!reg.test(value)) {
             this.setState({ id: undefined });
         }
     }
     render() {
         const { id, riderPhone, shipperPhone, consigneePhone, opId, type, isDelay, status, createTimeStart, createTimeEnd } = this.state;
         const { DeliveryOrderList, DeliveryOrderStatus, OrderDeliveryTypeEnum, CompanyItem: { dataList = [] } } = this.props;
         const systype = process.env.TYPE == 'OC' ? 'COMPANY' : 'ADMIN';
 
         return (
             <KeepAlive render={(state) => {
                 if (!this.state.__aliveInit) {
                     this.setState({ ...state, __aliveInit: true }, () => {
                         this._searchHandle('useCache');
                     });
                 }
             }}>
                 <div className={styles.flexBoxContainer}>
                 <div className={styles.orderContainer}>
                         <SearchBox>
                             <SearchItem>
                                 <XInput
                                     label='订单号'
                                     placeholder='请输入订单号'
                                     value={id}
                                     bindThis={this}
                                     bindName='id'
                                     // min={0}
                                     // precision={0}
                                     onBlur={this.deliveryIdHandle}
                                     maxLength={21}
                                 />
                             </SearchItem>
                             <SearchItem>
                                 <XInputNum
                                     label='骑士账号'
                                     placeholder='请输入骑士账号'
                                     value={riderPhone}
                                     bindThis={this}
                                     bindName='riderPhone'
                                     min={0}
                                     precision={0}
                                     maxLength={11}
                                 />
                             </SearchItem>
                             <SearchItem>
                                 <XInputNum
                                     label='发货人手机'
                                     placeholder='请输入发货人手机'
                                     value={shipperPhone}
                                     bindThis={this}
                                     bindName='shipperPhone'
                                     min={0}
                                     precision={0}
                                     maxLength={11}
                                 />
                             </SearchItem>
                             <SearchItem>
                                 <XInputNum
                                     label='收件人手机'
                                     placeholder='请输入收件人手机'
                                     value={consigneePhone}
                                     bindThis={this}
                                     bindName='consigneePhone'
                                     min={0}
                                     precision={0}
                                     maxLength={11}
                                 />
                             </SearchItem>
                             {
                                 systype == 'ADMIN' ? <SearchItem>
                                     <XSelect
                                         label='运营公司'
                                         placeholder='请选择运营公司'
                                         renderData={dataList}
                                         dataIndex='companyName'
                                         keyIndex='companyId'
                                         value={opId.companyName}
                                         showSearch={true}
                                         bindThis={this}
                                         bindName='opId'
                                     />
                                 </SearchItem> : null
                             }
                             <SearchItem>
                                 <XSelect
                                     label='是否超时'
                                     placeholder='请选择是否超时'
                                     renderData={[{ code: 1, value: '是' }, { code: 0, value: '否' }]}
                                     dataIndex='value'
                                     keyIndex='code'
                                     value={isDelay.value}
                                     showSearch={true}
                                     bindThis={this}
                                     bindName='isDelay'
                                 />
                             </SearchItem>
                             {this.state.curTabID == 1 && <SearchItem>
                                 <XSelect
                                     label='状态'
                                     placeholder='请选择状态'
                                     renderData={DeliveryOrderStatus}
                                     dataIndex='value'
                                     keyIndex='code'
                                     value={status.value}
                                     showSearch={true}
                                     bindThis={this}
                                     bindName='status'
                                 />
                             </SearchItem>}
                             <SearchItem>
                                 <XSelect
                                     label='订单类型'
                                     placeholder='请选择订单类型'
                                     renderData={OrderDeliveryTypeEnum}
                                     dataIndex='value'
                                     keyIndex='code'
                                     value={type.value}
                                     showSearch={true}
                                     bindThis={this}
                                     bindName='type'
                                 />
                             </SearchItem>
                             <SearchItem>
                                 <XDatePicker
                                     label='下单时间'
                                     value={createTimeStart}
                                     bindThis={this}
                                     bindName='createTimeStart'
                                     isFormat
                                     showTime={false}
                                     defaultTime='00:00:00'
                                     onChange={this.startDate}
                                 />
                                 <div className={styles.timeLine} />
                                 <XDatePicker
                                     style={{ marginRight: 20 }}
                                     label=''
                                     value={createTimeEnd}
                                     bindThis={this}
                                     bindName='createTimeEnd'
                                     isFormat
                                     showTime={false}
                                     defaultTime='23:59:59'
                                     disabledDate={this.disabledDate}
                                 />
                             </SearchItem>
                             <SearchItem>
                                 <XOKButton
                                     label='查询'
                                     onClick={this._searchHandle}
                                 />
                                 <XCancelButton
                                     label='重置'
                                     onClick={this._resetHandle}
                                 />
                             </SearchItem>
                         </SearchBox>
                     </div>
                     {/* <ButtonPerssion code='ordermanage/valueserviceorder/dc'>
                     <div className={styles.row2}>
                         <XOKButton
                             style={{ width: 'auto' }}
                             loading={this.state.shareLoading}
                             label='生成报表'
                             onClick={this._createHandle}
                         />
                     </div>
                     </ButtonPerssion> */}
                     {/* {this.state.curTabID !== 4 ? <TableContent
                         renderData={DeliveryOrderList}
                         tableAction={this._tableAction}
                         paginationChange={this._paginationChange}
                     /> : <MultiorderContent history={this.props.history} />} */}
                     <TableContent
                         renderData={DeliveryOrderList}
                         tableAction={this._tableAction}
                         paginationChange={this._paginationChange}
                     />
                 </div>
             </KeepAlive>
         );
     }
 }
 
 Main.propTypes = {
     history: PropTypes.object, // 路由
     match: PropTypes.object,
     getDeliveryOrderList: PropTypes.func,
     DeliveryOrderList: PropTypes.object,
     getDeliveryOrderStatus: PropTypes.func,
     DeliveryOrderStatus: PropTypes.array,
     getOrderDeliveryTypeEnum: PropTypes.func,
     OrderDeliveryTypeEnum: PropTypes.array,
     getCompanyItem: PropTypes.func,
     CompanyItem: PropTypes.object,
     setBreadcrumbPaths: PropTypes.func,
 };
 const mapStateToProps = (state) => ({
     DeliveryOrderList: state.microshippingorder.DeliveryOrderList,
     DeliveryOrderStatus: state.microshippingorder.DeliveryOrderStatus,
     OrderDeliveryTypeEnum: state.microshippingorder.OrderDeliveryTypeEnum,
     CompanyItem: state.microshippingorder.CompanyItem,
 });
 export default connect(mapStateToProps, { setBreadcrumbPaths, ...model.actions })(Main);